import { useEffect, useRef, useState } from 'react';
import { imgs } from '../assets/imgs';
import video from '../assets/videos/backgroundvideo.mp4';
import { Banner, CountDown, HSForm, ProgressBar, RegisterMeantime, TestimonialCarousel, TicketsForm } from '../components';
import { NavLink, Outlet, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useResizeImg } from '../hooks/useResizeImg';
import { useGlobalState } from '../hooks/useGlobalState';
import { ACTIONS } from '../state';
import { extractAddons, filterProperties, findNextIndex, getTicketsOneLevel, updateTags } from '../utils/funcs';
import { getData, postData } from '../utils/apiCalls';

export const Register = () => {
   const { deadline, tickets, discount, discounts, calculateTotal, dispatch, promoCode, cart, paymentInfo, price, processOrder, soldOut } = useGlobalState()
   const [isLoading, setIsLoading] = useState(true)
   const imageSource = useResizeImg(imgs.register.registerBannerDesktop, imgs.register.registerBannerMobile)
   const navigate = useNavigate()
   const { type } = useParams()
   const { search } = useLocation()
   const isFirstRun = useRef(true)

   useEffect(() => {
      updateTags("Venture Summit West | Registraion")
   }, [])

   useEffect(() => {
      if (!type) navigate('startups' + search)
   }, [type])

   useEffect(() => {
      getData('https://youngstartup.io/api/cwebsite-reg/get_ticket_types')
         .then(res => {
            dispatch({ type: ACTIONS.SET, entity: 'tickets', payload: res.ticket_categories })
            dispatch({ type: ACTIONS.SET, entity: 'ticketsArr', payload: getTicketsOneLevel(res.ticket_categories) })
            dispatch({ type: ACTIONS.SET, entity: 'discount', payload: res.discount })
            dispatch({ type: ACTIONS.SET, entity: 'soldOut', payload: res.sold_out })
            dispatch({ type: ACTIONS.SET, entity: 'discounts', payload: res.discounts })
            dispatch({ type: ACTIONS.SET, entity: 'deadline', payload: new Date(res.count_down_to) })
         })
   }, [])

   useEffect(() => {
      if (cart.length === 0) return
      dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: true })
      postData(`https://youngstartup.io/api/cwebsite-reg/get_tickets_addons?promo=${promoCode}`, {
         body: {
            tickets: cart
         }
      })
         .then(res => { dispatch({ type: ACTIONS.SET, entity: 'addOns', payload: res }) })
         .finally(() => dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: false }))
   }, [cart.length])

   useEffect(() => {
      if (cart.length === 0) return
      dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: true })
      postData('https://youngstartup.io/api/cwebsite-reg/get_total_price', {
         body: {
            promo_code: promoCode,
            tickets: extractAddons(cart)
         }
      })
         .then(res => dispatch({ type: ACTIONS.SET, entity: 'price', payload: { total: res.total_final, fees: res.fees, discount: res.discount } }))
         .finally(() => dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: false }))
   }, [extractAddons(cart).length, calculateTotal])

   useEffect(() => {
      if (cart.length === 0 || isFirstRun.current) {
         isFirstRun.current = false
         return
      }
      dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: true })
      postData('https://youngstartup.io/api/cwebsite-reg/process_order', {
         body: {
            promo_code: promoCode,
            tickets: extractAddons(cart),
            amount_paid: price.total,
            contact_info: filterProperties(paymentInfo, ['card_number', 'month', 'year', 'cvv']),
            cc_info: {
               card_number: paymentInfo.card_number,
               exp: `${paymentInfo.year}-${paymentInfo.month}`,
               cvv: paymentInfo.cvv,
            },
         }
      })
         .then(res => dispatch({ type: ACTIONS.SET, entity: 'orderResponse', payload: res }))
         .finally(() => dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: false }))

   }, [processOrder])

   return (
      <div className='register'>
         {/* <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h2>Book Your Tickets Now</h2>
            </section>
            <section >
               {deadline > new Date() && < CountDown deadline={deadline} />}
            </section>
         </Banner> */}
         <div className='banner video'>
            {isLoading &&
               <div className='shimmer-wrapper'>
                  <div className='shimmer'>
                     <video style={{ visibility: 'hidden' }} preload={'auto'} onLoadedData={() => setIsLoading(false)}>
                        <source src={video} type='video/mp4' />
                     </video>
                  </div>
               </div>}
            {!isLoading &&
               <video autoPlay loop muted>
                  <source src={video} type='video/mp4' />
               </video>}
            <div className='items-on-banner'>
               <section>
                  <h2>Book Your Tickets Now</h2>
               </section>
               <section >
                  {deadline > new Date() && < CountDown deadline={deadline} />}
               </section>
            </div>
         </div>
         {soldOut && <section className='sold-out'>
            <h1>The summit is sold out</h1>
            <p>A limited number of tickets have been reserved for walk-ins. To be added to a waitlist fill out your details below.</p>
         </section>}
         {soldOut && <HSForm id={'8b0104df-57bf-4a46-bef7-b8e2b9fad4d1'} />}
         {/* { <div id="HSForm" />} */}
         {!soldOut && <section>
            {discount > 0 && <div className='headers'>
               <h1>Register Now and Save ${discount}</h1>
               <h2>Use Promo Code: early{discount}</h2>
               <h2>Pre-registration savings available for a limited time</h2>
               <ProgressBar stages={discounts} currStageIdx={findNextIndex(discounts, 'is_past')} />
               <h4>Please select the ticket type most relevant to you.</h4>
            </div>}
            <nav>
               {tickets.length > 0 &&
                  tickets.map((tab, index) =>
                     <NavLink key={index}
                        className={type === tab.name ? 'btn' : 'btn b2'}
                        to={tab.name + search}>
                        {tab.name}
                     </NavLink>
                  )}
            </nav>
            {tickets.length > 0 && <Outlet />}
         </section>}
         <TestimonialCarousel pageName={"registration;"} />
         {!soldOut && <TicketsForm formid={'4986ecbd-1bb6-4f6c-a3d9-9c47b594b80b'} />}
      </div>
   )
}

